import { supportItems } from '@/mocks/home';
import SectionHead from './SectionHead';

export default function Quality() {
  return (
    <section id="quality" className="bg-background-100">
      <div className="max-w-[1280px] mx-auto px-5 md:px-10 lg:px-12 py-24 md:py-32">
        <SectionHead label="Quality & Support" title="CLARITY BEFORE EVERY ORDER." intro="A careful, documented process — so the component you receive matches the line it is meant for." />
        <div data-mo="group" className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-12 mt-14 md:mt-20">
          {supportItems.map((s) => (
            <div key={s.no} className="flex flex-col">
              <div className="h-px w-8 bg-primary-500 mb-6" />
              <h3 className="t-feature text-foreground-950">{s.title}</h3>
              <p className="mt-3 t-body text-foreground-600">{s.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}